"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colorHelpers_1 = require("./colorHelpers");
var themeColors = {
    AXS_BLUE: '#0054a1',
    BLACK: '#000000',
    BLACK_20: colorHelpers_1.opacify('#000000', '.2'),
    BLACK_70: colorHelpers_1.opacify('#000000', '.7'),
    BLACK_85: colorHelpers_1.opacify('#000000', '.85'),
    BLACK_RUSSIAN: '#040619',
    BLUE_10: '#11225f',
    BLUE_11: '#003268',
    BLUE_12: '#1d3570',
    BLUE_14: '#3b5583',
    BLUE_16: '#4a6694',
    BLUE_18: '#5f7697',
    BLUE_2: '#000410',
    BLUE_20: '#798daa',
    BLUE_22: '#a1aec2',
    BLUE_24: '#bbc7dc',
    BLUE_25: '#00205b',
    BLUE_3: '#000328',
    BLUE_3_20: colorHelpers_1.opacify('#000328', '.2'),
    BLUE_4: '#04061a',
    BLUE_6: '#000e2e',
    BLUE_7: '#02123a',
    BLUE_8: '#091746',
    BLUE_BLACK: '#1d1f31',
    BLUE_GRAY: '#182346',
    CTA_BLUE: '#007def',
    CTA_BLUE_ACTIVE: '#0060c4',
    CTA_BLUE_HOVER: '#007dff',
    DARK_MODE_WHITE: '#ebebeb',
    GREEN: 'axsui.status.success.default',
    GREEN_HOVER: 'axsui.status.success.hover',
    GREY_200: '#ededed',
    GREY_201: '#bcbcbc',
    GREY_DARK: '#929292',
    GREY_DARKER: '#717171',
    GREY_DARKEST: '#505050',
    GREY_LIGHT: '#cfcfcf',
    GREY_LIGHTER: '#dedede',
    GREY_LIGHTEST: '#f6f6f6',
    GREY_MEDIUM: '#aaaaaa',
    LIGHT_MODE_LT_BLUE: '#e4edf9',
    LINK_BLUE: '#007dff',
    LINK_BLUE_HOVER: '#0056b3',
    PERSIAN_GREEN: '#00A7A3',
    WHITE: '#ffffff',
    WHITE_20: colorHelpers_1.opacify('#ffffff', '.2'),
    WHITE_70: 'rgba(255, 255, 255, .7)',
};
exports.default = themeColors;
//# sourceMappingURL=themeColors.js.map